export default __webpack_public_path__ + "2c4a64e08246f0f5ff1309762133af10.png";